import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";
function Privacy() {
  return (
    <>
    
<Helmet>
  <title>Privacy Policy | Astro Logical Solutions</title>

  <meta
    name="description"
    content="Read the Privacy Policy of Astro Logical Solutions to understand how we collect, use, protect and manage your personal information."
  />

  <link
    rel="canonical"
    href="https://astrologicalsolutions.in/privacy-policy"
  />

  <meta
    name="robots"
    content="index, follow, max-image-preview:large"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Privacy Policy | Astro Logical Solutions"
  />
  <meta
    property="og:description"
    content="Learn how Astro Logical Solutions handles and protects your personal information."
  />
  <meta
    property="og:url"
    content="https://astrologicalsolutions.in/privacy-policy"
  />
  <meta
    property="og:site_name"
    content="Astro Logical Solutions"
  />
</Helmet>

      <Header />
      <div className="shipping-page">
        <section className="shipping-hero">
          <h1 className="page-title">
            Privacy Policy - Astro Logical <br /> Solutions
            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h1>
          <div className="hero-card">
            <span className="hero-badge">Your Privacy & Data Protection </span>
            <h2>Privacy Policy</h2>
            <div className="hero-stars">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
            <p className="hero-description">
              How Astro Logical Solutions collects, uses, protects, and shares
              your personal information. This Privacy Policy is written in clear
              and simple language and is intended to align with applicable data
              protection and privacy laws in India, including the Digital
              Personal Data Protection Act, 2023 and, where applicable, the
              Information Technology (Reasonable Security Practices and
              Procedures and Sensitive Personal Data or Information) Rules,
              2011.
            </p>
            <div className="shipping-points">
              <span>DPDP Act 2023 aligned</span>
              <span>SPDI Rules 2011</span>
              <span>Named Grievance Officer</span>
              <span>Your data, your rights</span>
            </div>
          </div>
        </section>

        <section className="shipping-details">
          <div className="content-section">
            <div className="section-heading">
              <h3>1. Personal Data We Collect</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We collect personal data that you provide directly, data collected
              automatically from your device, and data generated when you
              interact with our products, calculators and support team. We
              collect only what is needed for the purposes set out in Section 2.
            </p>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>What it includes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Identity & contact</strong>
                    </td>
                    <td>
                      Name, email address, phone number, billing and shipping
                      address.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Order & transaction</strong>
                    </td>
                    <td>
                      Products ordered, order value, GSTIN (if you provide one
                      for a B2B invoice), and transaction records. We do not
                      store full card numbers — card/UPI/net-banking details are
                      captured directly by our payment gateway.
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Astrological birth details (Sensitive)</strong>
                    </td>
                    <td>
                      Date of birth, time of birth, and place of birth — when
                      you voluntarily use our free gemstone / rudraksha
                      calculators or book a personal consultation. Any
                      forecasts, gemstone recommendations or predictions
                      generated from this data.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Device & usage ("Device Information")</strong>
                    </td>
                    <td>
                      Web browser, IP address, time zone, operating system,
                      device identifiers, approximate geo-location,
                      referring/exit pages, pages and products viewed, and
                      cookies installed on your device (via cookies, log files,
                      web beacons, tags and pixels).
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Communications & content</strong>
                    </td>
                    <td>
                      Messages you send us (WhatsApp, email, chat, calls) and
                      any reviews, comments or content you publish on the
                      Website.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>2. Lawful Purposes & Consent</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We process your personal data only for lawful, specified purposes
              and, where the DPDP Act requires it, on the basis of your consent
              or a legitimate use permitted by law. Our purposes are:
            </p>
            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Order fulfilment</h4>
                <p>
                  Processing payments, arranging shipping via our courier
                  partners, sending invoices and order confirmations, and
                  handling returns, refunds and cancellations.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Recommendations</h4>

                <p>
                  Generating gemstone and Rudraksha recommendations based on the
                  birth details you voluntarily provide through our Gemstone
                  Calculator, Rudraksha Calculator, or during a personal
                  consultation.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Communication & support</h4>

                <p>
                  Responding to your enquiries, sending service and order
                  updates, and providing customer support over WhatsApp, email
                  and phone.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Security & fraud</h4>

                <p>
                  Screening orders and device information (in particular your IP
                  address) for potential risk and fraud, and keeping the Website
                  and your data secure.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Analytics & improvement</h4>

                <p>
                  Creating anonymous, aggregated statistics to improve existing
                  products and services, develop new offerings, and assess the
                  success of our campaigns.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Marketing (with consent)</h4>

                <p>
                  Sending newsletters, offers and product updates by
                  email/SMS/WhatsApp where you have opted in or where permitted
                  by law. You can opt out at any time — see Data-Sharing
                  Opt-Out.
                </p>
              </div>
            </div>
            <br />
            <p>
              We process your personal information based on your consent where
              consent is required, including for optional activities such as
              marketing communications and the use of voluntarily provided birth
              details for astrological services. For other processing
              activities, we may rely on the need to fulfil our contractual
              obligations, legitimate business purposes such as fraud prevention
              and maintaining business records, and applicable legal or
              regulatory requirements, including tax and accounting obligations.
            </p>{" "}
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>3. How We Use & Share Your Data</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We do not sell, rent, or trade your personal information. We may
              share your information only with the categories of recipients
              described below and only when reasonably necessary for providing
              our products and services, operating our business, fulfilling
              legal obligations, or protecting our rights. We take reasonable
              steps to ensure that approved third-party service providers follow
              appropriate data-protection and security practices. Such providers
              may be required to comply with applicable privacy and
              data-protection laws, maintain confidentiality, and use your
              information only for the purposes for which it is shared, in
              accordance with this Privacy Policy and our contractual
              requirements.
            </p>
            <div className="timeline-table-wrapper">
              <table className="timeline-table">
                <thead>
                  <tr>
                    <th>Who we share with</th>
                    <th>Purpose</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Payment gateways</strong>
                    </td>
                    <td>
                      To securely process your payments (UPI, cards,
                      net-banking, wallets, EMI, COD). These processors capture
                      your payment credentials directly; we receive only the
                      transaction result and limited details.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Logistics & courier partners</strong>
                    </td>
                    <td>
                      To deliver your order — your name, shipping address and
                      phone number are shared with our shipping and courier
                      partners to complete and track delivery.
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Technology, hosting & e-commerce platform</strong>
                    </td>
                    <td>
                      To host the Website, store data securely, and operate our
                      storefront, order-management and customer-support systems.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Analytics & marketing service providers</strong>
                    </td>
                    <td>
                      To measure and improve site performance and to run
                      marketing/advertising (where permitted). We may share
                      anonymous, aggregated statistics that do not identify you.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Professional advisers & authorities</strong>
                    </td>
                    <td>
                      To comply with applicable laws and regulations, respond to
                      a subpoena, search warrant, court order or other lawful
                      request, enforce our terms, or protect our rights,
                      property and safety and those of others.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Business transfers</strong>
                    </td>
                    <td>
                      In connection with a merger, acquisition or sale of
                      assets, your data may be transferred to the successor
                      entity, which will remain bound by this Policy.{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>4. Cookies & Tracking</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We use cookies and similar technologies to ensure that the Website
              functions properly, remember your preferences, analyse how
              visitors use our Website, and support relevant marketing
              activities. You can manage, restrict, or disable cookies through
              your browser settings. For additional information about cookies,
              you may visit All About Cookies.
            </p>
            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Cookies</h4>
                <p>
                  Small data files placed on your device, often with an
                  anonymous unique identifier, to remember you and your
                  preferences.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Log files</h4>

                <p>
                  Track actions on the Site — IP address, browser type, ISP,
                  referring/exit pages and date/time stamps.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Web beacons, tags & pixels</h4>

                <p>
                  Electronic files that record how you browse the Site and help
                  us measure campaigns.
                </p>
              </div>
            </div>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>5. Data Retention</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We retain your personal data only for as long as necessary for the
              purposes it was collected, or as required to comply with legal,
              tax, accounting and regulatory obligations, to resolve disputes
              and to enforce our agreements. Order and invoice records are
              retained for the period required under applicable tax and company
              law. When your data is no longer required and no legal obligation
              compels us to keep it, we will erase or anonymise it. You may
              request deletion of your data at any time (see "Your Rights"),
              subject to these legal retention requirements.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>6. Your Rights as a Data Principal</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Under the DPDP Act, 2023 and applicable privacy laws, you have the
              following rights over your personal data — regardless of where you
              reside. To exercise any right, contact our Grievance Officer using
              the details in Section 10; we will verify your identity before
              acting on the request.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>7. Data Security</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We implement reasonable security practices and procedures designed
              to protect your personal data against unauthorised access,
              alteration, disclosure or destruction, in line with the SPDI
              Rules, 2011. These include secure hosting, access controls
              limiting data to personnel who need it, encryption in transit for
              payment and account pages, and contractual data-protection
              obligations on our service providers. Payment details are handled
              directly by PCI-compliant payment gateways and are not stored on
              our servers. While we work hard to protect your data, no method of
              transmission or storage over the internet is completely secure; in
              the unlikely event of a personal-data breach that affects you, we
              will act in accordance with applicable law.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>8. Children's Data</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              The Website and our services are intended for users aged 18 years
              and above. We do not knowingly collect personal data of a child (a
              person under 18) or of a person with a disability who has a lawful
              guardian, without the verifiable consent of a parent or lawful
              guardian, and we do not undertake tracking, behavioural monitoring
              or targeted advertising directed at children. If you are under 18,
              please use the Website only with the involvement and consent of
              your parent or guardian. If you believe a child's data has been
              shared with us without proper consent, please contact our
              Grievance Officer immediately and we will take appropriate steps
              to delete it from our systems.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>9. Cross-Border Data Transfer</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Astro Logical Solutions ships to customers in India and
              internationally. Where we use service providers (such as hosting,
              analytics or payment processors) whose systems are located outside
              India, your personal data may be processed or stored outside your
              country of residence. Where such transfers occur, we take steps to
              ensure your data continues to receive protection consistent with
              this Policy and applicable law, and we transfer data only to
              jurisdictions that are not restricted under the DPDP Act. By using
              the Website, you consent to such transfer, storage and processing
              as described here.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>10. Grievance Officer & Contact</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              If you have questions about this Policy, wish to exercise your
              rights, or would like to make a complaint about how your data is
              handled, please contact our Grievance Officer. We aim to
              acknowledge your request within 48 hours and resolve it within 30
              days, or sooner where the law requires.
            </p>
          </div>
          <div className="seller-grievance-box">
            <h3>Officer</h3>
            <p>
              <b>Name: Maneish RK Sharma</b>
            </p>
            <p>
              <strong>email:</strong> care.astroconsultation@gmail.co
            </p>
            <p>
              <strong>Registered Office:</strong> Shiva Aangan, Bachan Singh
              Colony, Lane No.9, Muzaffarnagar, Uttar Pradesh, 251001
            </p>
            <p>
              <strong>Customer Support:</strong>{" "}
              <a href="mailto:support@astrologicalsolutions.in">
                support@astrologicalsolutions.in
              </a>{" "}
              · WhatsApp{" "}
              <a
                href="https://wa.me/7351739191"
                target="_blank"
                rel="noreferrer"
              >
                +91 7351739191
              </a>{" "}
              · Mon–Sat, 10am–7pm IST
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>11. Changes to This Policy</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We may update this Privacy Policy from time to time to reflect
              changes in our practices, technology, or legal and regulatory
              requirements. Any updates take effect when posted on this page,
              and the "last updated" date below will be revised. Where changes
              are significant, we will take reasonable steps to notify you. We
              encourage you to review this page periodically. Your continued use
              of the Website after an update constitutes acceptance of the
              revised Policy.
            </p>
          </div>
          <div className="seller-grievance-box">
            <p>
              <b> Disclaimer </b>: Astro Logical Solutions products and any
              gemstone, rudraksha or astrological guidance are offered on the
              basis of traditional Vedic belief for spiritual and personal
              well-being. They are not a substitute for professional medical,
              financial or legal advice and are not claimed to diagnose, treat,
              cure or prevent any disease or to guarantee any specific outcome.
              Individual beliefs and results vary.
            </p>
          </div>
          <section className="delivery-section">
            <div className="delivery-content">
              <h2>Questions about your data?</h2>
              <p>
                Our team is here to help. Message us on WhatsApp for the fastest
                response, or email our Grievance <br /> Officer — we respond
                within 48 hours.
              </p>
              <div className="delivery-buttons">
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Chat on WhatsApp
                </a>
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Visit Help Center
                </a>
              </div>
            </div>
          </section>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
